document.addEventListener('DOMContentLoaded', function () {
  // Função para inicializar um carrossel
  function initializeCarousel(emblaNode) {
    if (!emblaNode) return

    const viewportNode = emblaNode.querySelector('.embla__viewport')
    const prevButton = emblaNode.parentElement.querySelector('.embla__prev')
    const nextButton = emblaNode.parentElement.querySelector('.embla__next')
    const dotsNode = emblaNode.querySelector('.embla__dots')
    const dotButtons = dotsNode ? dotsNode.querySelectorAll('.embla__dot') : []

    if (!viewportNode) return

    // Configurações diferentes baseadas no tipo de carrossel
    const isDestaqueCarousel = emblaNode.classList.contains('embla--destaque')
    const options = {
      loop: false,
      align: 'start',
    }

    // Adicionar autoplay apenas no carrossel de destaques
    if (isDestaqueCarousel) {
      options.loop = true
    }

    // eslint-disable-next-line no-undef
    const embla = EmblaCarousel(viewportNode, options)

    // Autoplay para carrossel de destaques
    let autoplayInterval
    if (isDestaqueCarousel) {
      const startAutoplay = () => {
        autoplayInterval = setInterval(() => {
          embla.scrollNext()
        }, 5000) // 5 segundos
      }

      const stopAutoplay = () => {
        clearInterval(autoplayInterval)
      }

      // Iniciar autoplay
      startAutoplay()

      // Parar autoplay quando o usuário interagir
      emblaNode.addEventListener('mouseenter', stopAutoplay)
      emblaNode.addEventListener('mouseleave', startAutoplay)
      emblaNode.addEventListener('touchstart', stopAutoplay)
    }

    // Função para atualizar dots
    function updateDots() {
      if (dotButtons.length === 0) return

      dotButtons.forEach((dot, index) => {
        dot.classList.remove('embla__dot--selected')
        if (index === embla.selectedScrollSnap()) {
          dot.classList.add('embla__dot--selected')
        }
      })
    }

    // Event listeners para dots
    dotButtons.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        embla.scrollTo(index)
      })
    })

    if (prevButton && nextButton) {
      // Funções dos botões
      prevButton.addEventListener('click', () => embla.scrollPrev())
      nextButton.addEventListener('click', () => embla.scrollNext())

      function disablePrevNextButtons() {
        if (!isDestaqueCarousel) {
          // Não desabilitar botões se for loop
          embla.canScrollPrev()
            ? prevButton.removeAttribute('disabled')
            : prevButton.setAttribute('disabled', 'disabled')

          embla.canScrollNext()
            ? nextButton.removeAttribute('disabled')
            : nextButton.setAttribute('disabled', 'disabled')
        }
      }

      embla.on('select', disablePrevNextButtons)
      disablePrevNextButtons()
    }

    // Atualizar dots quando o slide mudar
    embla.on('select', updateDots)
    updateDots()
  }

  // Inicializar todos os carrosséis na página
  const emblaNodes = document.querySelectorAll('.embla')
  emblaNodes.forEach(initializeCarousel)
})
